export default {
  // env: 'production'
  env: 'mock'
};



// WEBPACK FOOTER //
// ./src/main/assets/js/api/config.js